import BottomNav from '@/components/BottomNav';
import DemoBanner from '@/components/DemoBanner';
import useReminderNotifications from '@/hooks/useReminderNotifications';
import { useDemo } from '@/contexts/DemoContext';

/**
 * AppLayout - Layout wrapper with persistent bottom navigation
 * 
 * Structure:
 * 1. Demo Banner (when active) - Part of normal document flow, NOT fixed
 * 2. Page Content - Scrolls naturally below banner
 * 3. Bottom Navigation - Fixed at bottom with safe area
 * 
 * The demo banner is rendered INSIDE the layout as part of normal flow,
 * so it pushes content down instead of overlapping it.
 * 
 * Bottom Navigation Heights:
 * - Nav bar: 64px (h-16)
 * - Safe area bottom: env(safe-area-inset-bottom)
 * - Plus button overlap: ~20px above nav
 * - Total clearance needed: ~128px (pb-32)
 */

const AppLayout = ({ children, hideNav = false }) => {
  // Initialize reminder notifications
  useReminderNotifications();
  
  // Check if demo mode is active
  const { isDemoMode } = useDemo();
  
  return (
    <div 
      className="min-h-screen pastel-gradient flex flex-col"
      data-demo-mode={isDemoMode ? 'true' : 'false'}
    >
      {/* Demo Banner - Part of normal flow, pushes content down */}
      <DemoBanner />
      
      {/* Main content wrapper */}
      {/* pb-32 = 128px ensures content clears floating + button and nav bar */}
      <div className={`flex-1 ${hideNav ? '' : 'pb-32'}`}>
        {children}
      </div>
      
      {/* Persistent bottom navigation - Fixed at bottom */}
      {!hideNav && <BottomNav />}
    </div>
  );
};

export default AppLayout;
